import { Component, OnInit, AfterViewInit, AfterViewChecked, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';

// import { GoogleAuth, OAuth2Client } from 'google-auth-library';
// import { ReCaptchaV3Service } from 'ng-recaptcha';

// import { rcConfig } from '@src/config/recaptcha.config';

import { Message } from '@src/app/shared/interfaces/message';

import { AnalyticsService } from 'src/app/shared/services/fb-analytics.service';
import { GeneralService, debounce } from '@src/app/shared/services/general.service';
import { MessageService } from '@src/app/shared/services/message.service';
import { submitState } from '@src/app/shared/animations/animations';

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
	styleUrls: ['./contact-form.component.scss'],
	animations: [
		submitState
	]
})

export class ContactFormComponent implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy {
  message?: Message;
	messageSub: Subscription;
	addUserSub: Subscription;

	// recaptchaSub: Subscription;

	submitState: boolean = false;
	successState: boolean = false;
	failureState: boolean = false;
	addedToDB: boolean = false;
	
	contactForm: FormGroup;
	subscribeUser: boolean = false;

	constructor(
		private formBuilder: FormBuilder,
		private http: HttpClient,
		// private rcV3Service: ReCaptchaV3Service,
		protected analyticsService: AnalyticsService,
		protected generalService: GeneralService,
		private messageService: MessageService
	) { }


	@debounce(750)
	trackTxtInput($event: any): void {
		this.analyticsService.trackInput($event);
	}

	sendMessage($event: any): void {
		const sendMsg = (val) => this.messageService.sendMessage(val);
		
		/* this.recaptchaSub = rcExec.subscribe(
			(token) => { */
				if (this.contactForm.valid && !this.submitState) {
					const formValue = this.contactForm.value;

					this.analyticsService.trackInput($event);

					if (this.messageSub)
						this.messageSub.unsubscribe();

					this.submitState = true;

					this.message = {
						replyTo: formValue.email,
						subject: `New Message from ${formValue.name}: ${formValue.subject}`,
						text: formValue.msgBody,
						html: formValue.msgBody
					}
					
					this.messageSub = sendMsg(this.message).subscribe(res => {
						if (res.error) {
							this.submitState = false;
							return this.failureState = true;
						}

						this.addUserSub = this.messageService.subscribeUser(
							formValue.email,
							{
								'source': 'contact_form',
								'subscribed': this.subscribeUser,
								'first_name': formValue.name
							}
						).subscribe(r2 => {
							if (r2.error)
								return this.addedToDB = false;

							this.addedToDB = true;
							this.submitState = false;
							this.successState = true;
						});
						this.contactForm.reset();
					});
				}
			/* }, 
			(error) => {
				console.error('Recaptcha v3 error:', error);
				this.failureState = true;
			}
		) */
	}

	getSubmitMsg(): string {
		if (this.submitState)
			return 'Sending&hellip;';

		if (this.successState) {
				if (this.subscribeUser && !this.addedToDB)
					return '<strong>Your message has been sent, but something went wrong with your newsletter subscription.</strong><br /><br /> Please try subscribing again by using a newsletter banner.';

			return 'Your message has been sent!';
		}

		if (this.failureState)
			return 'Sorry, something went wrong. Please try again later.';
	}

	closeConf($event: Event): void {
		this.analyticsService.trackInput($event);

		if (this.messageSub)
			this.messageSub.unsubscribe();
			
		if (this.submitState)
			this.submitState = false;

		if (this.successState)
			this.successState = false;

		if (this.failureState)
			this.failureState = false;
	}

	// Lifecycle Hooks

	ngOnInit(): void {
		// Initialize reactive form here to ensure FormBuilder has been injected
		this.contactForm = this.formBuilder.group({
			name: ['', Validators.required],
			email: ['', [Validators.required, Validators.email]],
			subject: ['', Validators.required],
			msgBody: ['', Validators.required],
			nlSignup: ['']
		});
	}

	ngAfterViewInit(): void {
	}

	ngAfterViewChecked(): void {
	}

	ngOnDestroy(): void {
		// this.recaptchaSub.unsubscribe();
		this.messageSub?.unsubscribe();
		this.addUserSub?.unsubscribe();
	}
}
